var map = {
	"./ar/main.yml": 71,
	"./bg/main.yml": 72,
	"./br/main.yml": 73,
	"./ca/main.yml": 74,
	"./de/main.yml": 75,
	"./el/main.yml": 76,
	"./en/main.yml": 77,
	"./eo/main.yml": 78,
	"./es/main.yml": 79,
	"./eu/main.yml": 80,
	"./fr/main.yml": 81,
	"./gl/main.yml": 82,
	"./hu/main.yml": 83,
	"./it/main.yml": 84,
	"./ja/main.yml": 85,
	"./nl/main.yml": 86,
	"./oc/main.yml": 87,
	"./pl/main.yml": 88,
	"./pt_BR/main.yml": 89,
	"./pt_PT/main.yml": 90,
	"./ru/main.yml": 91,
	"./sq/main.yml": 92,
	"./sv/main.yml": 93,
	"./tr/main.yml": 94,
	"./uk/main.yml": 95,
	"./vi/main.yml": 96,
	"./zh_Hant_TW/main.yml": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;